export default __webpack_public_path__ + "static/media/product_15.ed1c15e2.png";